export default "__VITE_ASSET__DSN52S3D__"